import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { formatDateDb } from "../utils/tools";
import { customDateFormatType } from "../utils/utils";

const NUMBER_NFT_PER_PAGE = 25;
const queryKey = "employeeKPI";

async function fetchEmployeeKPI(code, monthDate) {
  try {
    const options = {};

    if (code) options.code = code;
    if (monthDate) {
      options.month = Number(monthDate.getMonth() + 1);
      options.year = monthDate.getFullYear();
    }

    const queryParams = new URLSearchParams(options).toString();
    const data = await clientAPI(
      "get",
      `/document/api/v2/msh/evaluations/sale-kpis/monthly/detail?${queryParams}`,
    );

    const consultations = data?.consultations.map((item, index) => {
      return {
        code: item?.customerCode || "-",
        name: item?.customerName || "-",
        phone: item?.customerPhone || "-",
        date: item?.metricDate ? formatDateDb(item?.metricDate) : "-",
      };
    });
    const leads = data?.leads.map((item, index) => {
      return {
        code: item?.customerCode || "-",
        name: item?.customerName || "-",
        phone: item?.customerPhone || "-",
        date: item?.metricDate ? formatDateDb(item?.metricDate) : "-",
      };
    });
    const transactions = data?.transactions.map((item, index) => {
      return {
        code: item?.productCode || "-",
        name: item?.customerName || "-",
        phone: item?.customerPhone || "-",
        date: item?.transactionDate ? formatDateDb(item?.transactionDate) : "-",
      };
    });
    const missingLeadOrConsultTransactions = data?.missingLeadOrConsultTransactions.map(
      (item, index) => {
        return {
          code: item?.customer?.code || "-",
          name: item?.customer?.name || "-",
          phone: item?.customer?.phone || "-",
          date: item?.bookingTime ? formatDateDb(item?.bookingTime) : "-",
        };
      },
    );
    const newData = {
      employee: data?.employee,
      evaluation: data?.evaluation,
      consultCount: data?.evaluation?.metrics?.consultCount || 0,
      leadCount: data?.evaluation?.metrics?.leadCount || 0,
      transactionCount: data?.evaluation?.metrics?.transactionCount || 0,
      locking: data?.evaluation?.metrics?.locking || 0,

      consultations: consultations,
      leads: leads,
      transactions: transactions,
      missingLeadOrConsultTransactions: missingLeadOrConsultTransactions,
    };

    return { data: newData };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return {
      data: {
        employee: null,
        evaluation: null,
        consultCount: 0,
        leadCount: 0,
        transactionCount: 0,
        locking: 0,

        consultations: [],
        leads: [],
        transactions: [],
        missingLeadOrConsultTransactions: [],
      },
    };
  }
}

export function useEmployeeKPI(code, monthDate) {
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, code, monthDate],
    queryFn: () => fetchEmployeeKPI(code, monthDate),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  return {
    employeeKPI: data?.data,
    refetch,
    isLoading,
    isRefetching,
  };
}
